import { useEffect, useState } from 'react';
import {
  useGetDerivationsQuery,
  useCreateDerivationMutation,
  useUpdateDerivationMutation,
  useDeleteDerivationMutation,
} from '@/pages/SILA/services/derivations.service';
import { skipToken } from '@reduxjs/toolkit/query';
import { Derivation } from '../interfaces/Derivation';
import { UseDerivationsProps } from '../interfaces/DerivationProps';

const useDerivations = ({
  filters = {},
  page = 0,
  pageSize = 200,
  skip,
}: UseDerivationsProps) => {
  const queryParams = skip
    ? skipToken
    : {
        filters: {
          ...filters,
        },
        paginated: { page, pageSize },
      };

  const { data, isLoading, error, refetch } = useGetDerivationsQuery(
    queryParams,
    {
      pollingInterval: 10000,
      skip: skip || false,
    }
  );
  const [localDerivations, setLocalDerivations] = useState<Derivation[]>([]);
  useEffect(() => {
    if (data?.items) {
      setLocalDerivations(data.items);
    }
  }, [data]);

  const [createDerivation] = useCreateDerivationMutation();
  const [updateDerivation] = useUpdateDerivationMutation();
  const [deleteDerivation] = useDeleteDerivationMutation();
  return {
    isLoading,
    error,
    derivations: localDerivations,
    totalItems: data?.count ?? 0,
    totalPages: Math.ceil((data?.count ?? 0) / pageSize),
    currentPage: page,
    pageSize,
    refetch,
    createDerivation,
    updateDerivation,
    deleteDerivation,
  };
};

export default useDerivations;
